import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readAllByEmisor: (emisor, cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readAllByEmisor($emisor: ID!, $cursor: String, $limit: Int, $filter: Filter) {
            Descuento {
              readAllByEmisor(emisor: $emisor, cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  _id
                  naturalezaDescuento
                  porcentajeDescuento
                  montoDescuento
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Descuento.readAllByEmisor),

  create: item =>
    api
      .send({
        query: gql`
          mutation create($item: DescuentoInput!) {
            Descuento {
              create(input: $item) {
                _id
              }
            }
          }
        `,
        variables: {
          item
        }
      })
      .then(result => result.data.data.Descuento.create),

  readById: _id =>
    api
      .send({
        query: gql`
          query readById($_id: ID!) {
            Descuento {
              readById(_id: $_id) {
                _id
                naturalezaDescuento
                porcentajeDescuento
                montoDescuento
              }
            }
          }
        `,
        variables: { _id }
      })
      .then(result => result.data.data.Descuento.readById),

  delete: input =>
    api
      .send({
        query: gql`
          mutation delete($input: [ID!]!) {
            Descuento {
              delete(input: $input) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { input }
      })
      .then(result => result.data.data.Descuento.delete)
}
